import { useState, useEffect } from "react";
import Header from "../header/Header";
import Sidebar from "../Sidebar/Sidebar";
import "./Layout.css";
import { Outlet } from "react-router-dom";
import { GoLiveProvider } from "../../../context/SchoolGoLiveContext/GoLiveContext";

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false); // For mobile
  const [isCollapsed, setIsCollapsed] = useState(false); // For desktop

  // Check if we're on mobile
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (isMobile) {
      setSidebarOpen(!sidebarOpen); // Toggle open/close on mobile
    } else {
      setIsCollapsed(!isCollapsed); // Toggle collapse on desktop
    }
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <div className="layout">
      <Sidebar
        isOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isCollapsed={isCollapsed}
      />
      <GoLiveProvider>
        <Header
          toggleSidebar={toggleSidebar}
          isCollapsed={isCollapsed}
          isMobile={isMobile}
        />

        {/* Overlay for mobile */}
        {sidebarOpen && <div className="overlay" onClick={closeSidebar}></div>}

        <main
          className={`main-content ${isCollapsed ? "sidebar-collapsed" : ""}`}
        >
          <div className="content-wrapper">
            <Outlet />
          </div>
        </main>
      </GoLiveProvider>
    </div>
  );
};

export default Layout;
